import { useState, type FormEvent } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daimd23oh653ivfvogb0";

type Status = "idle" | "submitting" | "success" | "error";

export default function ContactForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");
  const [count, setCount] = useState(0);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const honey = String(data.get("website_alt") ?? "").trim();
    if (honey) {
      setStatus("success");
      form.reset();
      setCount(0);
      return;
    }

    setStatus("submitting");
    setFormError("");

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, String(value));
    });

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const okCode = parsed?.code === "OK";

      if (!response.ok || !okCode || /spam/i.test(serverMsg)) {
        setStatus("error");
        setFormError(serverMsg && !/spam/i.test(serverMsg) ? serverMsg : "提交没有成功,请稍后再试一次。");
        return;
      }

      setStatus("success");
      form.reset();
      setCount(0);
    } catch {
      setStatus("error");
      setFormError("网络有点问题,请检查连接后再试一次。");
    }
  }

  return (
    <form id="contact-team-form" data-readdy-form onSubmit={handleSubmit} className="rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-7" noValidate>
      <h3 className="font-heading font-bold text-xl text-foreground-950 mb-5">给社区团队留言</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <label className="block">
          <span className="block text-sm text-foreground-700 mb-1.5">怎么称呼你</span>
          <input
            type="text"
            name="name"
            required
            placeholder="你的昵称"
            className="w-full px-4 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
          />
        </label>
        <label className="block">
          <span className="block text-sm text-foreground-700 mb-1.5">邮箱</span>
          <input
            type="email"
            name="email"
            required
            placeholder="your@email.com"
            className="w-full px-4 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
          />
        </label>
      </div>

      <label className="block mt-4">
        <span className="block text-sm text-foreground-700 mb-1.5">想聊的事</span>
        <select
          name="topic"
          defaultValue="内容反馈"
          className="w-full px-4 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400"
        >
          <option value="内容反馈">内容反馈</option>
          <option value="社区合作">社区合作</option>
          <option value="加入创作者">加入创作者</option>
          <option value="使用问题">使用问题</option>
        </select>
      </label>

      <label className="block mt-4">
        <span className="block text-sm text-foreground-700 mb-1.5">具体内容</span>
        <textarea
          name="message"
          required
          rows={5}
          maxLength={500}
          onChange={(e) => setCount(e.target.value.length)}
          placeholder="详细说说你的想法或遇到的问题,我们都会认真看。"
          className="w-full px-4 py-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
        ></textarea>
      </label>
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-xs text-foreground-400">{count}/500</span>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-honey-field"
      />

      <div className="flex flex-col sm:flex-row items-center gap-3 mt-5">
        <button
          type="submit"
          disabled={status === "submitting"}
          className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {status === "submitting" ? <><i className="ri-loader-4-line animate-spin"></i>提交中</> : <><i className="ri-send-plane-fill"></i>发送留言</>}
        </button>
        {status === "success" && (
          <p className="text-sm text-secondary-700 flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line"></i>
            收到啦,我们会尽快回复你。
          </p>
        )}
        {status === "error" && (
          <p className="text-sm text-primary-700 flex items-center gap-1.5">
            <i className="ri-error-warning-line"></i>
            {formError}
          </p>
        )}
      </div>
    </form>
  );
}